<div class="transport-item {{transport?.style}}" [style.left]="((transport.column-(offsetBefore*60)) * scale +1) + 'px'"
    [style.width]="(transport.width * scale -1) + 'px'">
    <div class="visual" [ngClass]="{'selected': selected}">
        <sc-padding [half]="true">
            <div class="carrier-label">{{transport.carrier}} - {{transport.numberPlate}}</div>
            <sc-content-spacer vertical [half]="true"></sc-content-spacer>
            <div class="reference-label">{{transport.reference}}</div>
            <sc-content-spacer vertical [half]="true"></sc-content-spacer>
            <div class="options-label">{{transport.options}}</div>
        </sc-padding>
    </div>
</div>
